import React, { Fragment, useCallback, useMemo } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import globalMessages from '../../../utils/translations'
import copyToClipBoard from '../../../utils/copyToClipBoard'

import getGatsbyImage from '../../../utils/getGatsbyImage'
import CommonImageContainer from './commons/CommonImageContainer'

import type { CountryCode } from '../types'

export default function ShareButtonSection({
  slice,
}: {
  slice: Queries.PrismicEventPageDataBodyShareButton
}) {
  const item = slice.primary
  const country = process.env.REACT_APP_COUNTRY_CODE as CountryCode
  const translateWords = useMemo(() => globalMessages(country), [country])
  const image = getGatsbyImage(item.share_button_image?.localFile)
  const handleClickShareButton = useCallback(
    (shareUrl: string | null) => {
      try {
        if (shareUrl && shareUrl !== 'null') {
          copyToClipBoard(shareUrl)
          alert(translateWords.copyButtonModal)
        }
      } catch (err) {
        alert(translateWords.unknownErrorMessage)
      }
    },
    [translateWords],
  )
  return (
    <Fragment>
      <CommonImageContainer
        onClick={handleClickShareButton.bind(
          null,
          item.share_button_web_link || item.share_button_share_link,
        )}
      >
        {image && (
          <GatsbyImage
            image={image}
            alt={item.share_button_image?.alt || ''}
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        )}
      </CommonImageContainer>
    </Fragment>
  )
}
